import React, {useState} from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {handleModalState} from '@pluto/utils';
import {
    KeyboardDateTimePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import Typography from '@material-ui/core/Typography';

import './QCManagerJobsControlButtons.scss';

export interface QCManagerJobsHeaderProps {
    handleUserUnAssign: () => void;
    onMultipleJobDueDateChange: (dateValue: any) => void;
    handleMultiChangePriorityModal: () => void;
    handleMultiChangeAssigneeModal: () => void;
    checkedItems: number[];
    rowsLength: number;
}

export const getSelectedItemText = (selectedItemsLength: number, rowsLength: number) => {
    let itemsLabel = 'item';
    
    if (selectedItemsLength > 1) {
        itemsLabel = 'items';
    }
    
    if (selectedItemsLength > 0)
        return `${selectedItemsLength} ${itemsLabel} selected`;
    
    return `${rowsLength} items`;
};

const QCManagerJobsControlButtons = (props: QCManagerJobsHeaderProps) => {
    const {
        handleMultiChangePriorityModal,
        handleMultiChangeAssigneeModal,
        onMultipleJobDueDateChange,
        handleUserUnAssign,
        checkedItems,
        rowsLength,
    } = props;
    const checkedItemsLength = checkedItems.length;
    const selectedItems = getSelectedItemText(checkedItemsLength, rowsLength);
    const [openDueDatePicker, setOpenDueDatePicker] = useState<boolean>(false);
    
    return (
        <div className="qc-manager-control-buttons__wrapper">
            <Typography
                variant="h5"
                className="control-buttons__elem control-buttons__elem_title"
            >
                QC JOBS
            </Typography>
            <div className="control-buttons__elem control-buttons__elem_selected-items">
                {selectedItems}
            </div>
            {checkedItemsLength > 0 && (
                <div className="control-buttons__elem control-buttons__elem_links">
                    <div
                        role="button"
                        className="control-link contol-link_priority"
                        onClick={handleMultiChangePriorityModal}
                    >
                        Set priority
                    </div>
                    <div className="control-link control-link_due-date">
                        <span
                            role="button"
                            onClick={handleModalState(setOpenDueDatePicker, true)}
                        >
                            Set due date
                        </span>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDateTimePicker
                                okLabel={<span className="date-picker__label date-picker__label_save">Save</span>}
                                cancelLabel={<span className="date-picker__label date-picker__label_cancel">Cancel</span>}
                                disablePast
                                showTodayButton
                                todayLabel={<span className="date-picker__label date-picker__label_today">Today</span>}
                                onClose={handleModalState(setOpenDueDatePicker, false)}
                                open={openDueDatePicker}
                                inputVariant="outlined"
                                format="MM-dd-yyyy HH:mm"
                                margin="normal"
                                placeholder="MM-dd-yyyy HH:mm"
                                value={null}
                                onChange={onMultipleJobDueDateChange}
                                ampm={false}
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <div
                        role="button"
                        className="control-link control-link_assignee"
                        onClick={handleMultiChangeAssigneeModal}
                    >
                        Set Assignee
                    </div>
                    <div
                        role="button"
                        onClick={handleUserUnAssign}
                        className="control-link control-link_unassign"
                    >
                        Unassign selected items
                    </div>
                </div>
            )}
        </div>
    );
};

export default QCManagerJobsControlButtons;
